import styled from "styled-components";

export const CopyTradeSettingBodyWrapper = styled.div`
  height: 70%;
  overflow-y: auto;
`;
